import { translate } from "@escapio/shared/l10n/translate";

export const NONE = "none";
export const BREAKFAST = "breakfast";
export const HALF_BOARD = "half_board";
export const FULL_BOARD = "full_board";
const ALL_INCLUSIVE = "all_inclusive";

const BOARDS = {
	[NONE]: 0,
	[BREAKFAST]: 1,
	[HALF_BOARD]: 2,
	[FULL_BOARD]: 3,
	[ALL_INCLUSIVE]: 4,
};

export const isValid = board => board in BOARDS;

export const isAtLeast = (target, subject) => BOARDS[subject] >= BOARDS[target];

export const OPTIONS = {
	[NONE]: translate("hotel_price_comparer_filter_none"),
	[BREAKFAST]: translate("hotel_price_comparer_filter_breakfast_at_least"),
	[HALF_BOARD]: translate("hotel_price_comparer_filter_half_board"),
};

export const TRACKING_LABELS = {
	[NONE]: "Beliebig",
	[BREAKFAST]: "Frühstück",
	[HALF_BOARD]: "Halbpension",
};
